export class OperatorUtils {
  static mergeArrayOfObject(draft, db) {
    const array = [];
    for (let i = 0; i < Math.max(draft.length, db.length); i++) {
      const existsInDb = i in db;
      const existsInDraft = i in draft;

      if (existsInDb && existsInDraft) {
        array.push({...db[i], ...draft[i]});
      }
      if (!existsInDb && existsInDraft) {
        array.push({...draft[i]});
      }
      if (existsInDb && !existsInDraft) {
        array.push({...db[i]});
      }
      if (!existsInDb && !existsInDraft) {
        array.push(null);
      }
    }
    return array;
  }
}
